import { reducerCreator } from 'redux-rest-helper-for-loopback';
import PaymentXmlInitialValues from './PaymentXmlInitialValues';
import PaymentXmlsAction from './PaymentXmlsAction';

export default reducerCreator(PaymentXmlsAction.ENTRY, PaymentXmlInitialValues).getReducer();
